// @flow


import * as uiMenuSelectors from './uiMenu';
import * as uiSelectedLeagueSelectors from './uiSelectedLeague';
import * as checksumsSelectors from "./checksums";
import * as leagueDraftSelectors from './league';
import * as complexSelectors from './complex';
import * as teamDraftSelectors from './team';
import * as notificationSelectors from './notifications';
import * as playersSelectors from './players';
import * as positionsSelectors from './positions';
import * as roundsSelectors from './rounds';
import * as squadsSelectors from './squads';
import * as venuesSelectors from './venues';

export * from './user';
export * from './team';
export * from './league';
export * from './users';



export const rounds = roundsSelectors;
export const players = {
	...playersSelectors
};

export const squads = {
	...squadsSelectors,
};

export const venues = venuesSelectors;
export const positions = positionsSelectors;
export const leagueDraft = leagueDraftSelectors.default;
export const teamDraft = teamDraftSelectors;
export const checksums = checksumsSelectors;
export const complex = complexSelectors.default;

export const uiMenu = uiMenuSelectors;
export const uiSelectedLeague = uiSelectedLeagueSelectors;
export const notificationBar = notificationSelectors;


// WEBPACK FOOTER //
// ./src/modules/selectors/index.js